import type { ReactNode } from "react";
import type { FormProps } from "@circle-react-shared/uikit/Form/Form";
import { Form } from "@circle-react-uikit/Form";
import { mapSettingsToDefaultFromValues } from "./helpers";

interface EditHomeFormProps extends FormProps<Record<string, any>> {
  children: ReactNode;
  initialFormValues: Record<string, any>;
  onCancel?: () => void;
  onSubmit: (values: any) => void;
  settings: any;
}

export const EditHomeForm = ({
  onSubmit,
  settings,
  children,
  ...rest
}: EditHomeFormProps) => {
  const formDefaultValues = mapSettingsToDefaultFromValues(settings);

  return (
    <Form
      id="edit-home-form"
      onSubmit={onSubmit}
      defaultValues={formDefaultValues}
      {...rest}
    >
      {children}
    </Form>
  );
};
